var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.2601H10.93C10.48 19.2601 10.11 18.8901 10.11 18.4401C10.11 17.9901 10.48 17.6201 10.93 17.6201H20C20.45 17.6201 20.82 17.9901 20.82 18.4401C20.82 18.9001 20.45 19.2601 20 19.2601Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.9701H10.93C10.48 12.9701 10.11 12.6001 10.11 12.1501C10.11 11.7001 10.48 11.3301 10.93 11.3301H20C20.45 11.3301 20.82 11.7001 20.82 12.1501C20.82 12.6001 20.45 12.9701 20 12.9701Z",
    fill: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.67027H10.93C10.48 6.67027 10.11 6.30027 10.11 5.85027C10.11 5.40027 10.48 5.03027 10.93 5.03027H20C20.45 5.03027 20.82 5.40027 20.82 5.85027C20.82 6.30027 20.45 6.67027 20 6.67027Z",
    fill: "#007AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.91005 8.02992C4.69005 8.02992 4.48005 7.93992 4.33005 7.78992L3.42005 6.87992C3.10005 6.55992 3.10005 6.03992 3.42005 5.71992C3.74005 5.39992 4.26005 5.39992 4.58005 5.71992L4.91005 6.04992L7.05005 3.90992C7.37005 3.58992 7.89005 3.58992 8.21005 3.90992C8.53005 4.22992 8.53005 4.74992 8.21005 5.06992L5.49005 7.78992C5.33005 7.93992 5.13005 8.02992 4.91005 8.02992Z",
    fill: "#007AFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.91005 14.3297C4.70005 14.3297 4.49005 14.2497 4.33005 14.0897L3.42005 13.1797C3.10005 12.8597 3.10005 12.3397 3.42005 12.0197C3.74005 11.6997 4.26005 11.6997 4.58005 12.0197L4.91005 12.3497L7.05005 10.2097C7.37005 9.88973 7.89005 9.88973 8.21005 10.2097C8.53005 10.5297 8.53005 11.0497 8.21005 11.3697L5.49005 14.0897C5.33005 14.2497 5.12005 14.3297 4.91005 14.3297Z",
    fill: "#007AFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.91005 20.3297C4.70005 20.3297 4.49005 20.2497 4.33005 20.0897L3.42005 19.1797C3.10005 18.8597 3.10005 18.3397 3.42005 18.0197C3.74005 17.6997 4.26005 17.6997 4.58005 18.0197L4.91005 18.3497L7.05005 16.2097C7.37005 15.8897 7.89005 15.8897 8.21005 16.2097C8.53005 16.5297 8.53005 17.0497 8.21005 17.3697L5.49005 20.0897C5.33005 20.2497 5.12005 20.3297 4.91005 20.3297Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskActive);
export default __webpack_public_path__ + "static/media/task-active.544f315db623aa9abb103b0394270481.svg";
export { ForwardRef as ReactComponent };